module.exports = __webpack_public_path__ + "img/icon_deal__net@3x.9e99db42.png";